import { useEffect } from 'react';
import { Platform } from 'react-native';
import Purchases, { LOG_LEVEL } from 'react-native-purchases';
import { useLoadedUser } from './api/useUser';

export const useInitializePayments = () => {
    const { user } = useLoadedUser({});
    useEffect(() => {
        if (Platform.OS === 'web') return;

        Purchases.setLogLevel(LOG_LEVEL.VERBOSE);

        if (Platform.OS === 'android') {
            Purchases.configure({ apiKey: 'goog_AHQjBgkTnhYPkgeNniOrrsePvvk', appUserID: user.userId });
        } else if (Platform.OS === 'ios') {
            Purchases.configure({ apiKey: 'appl_BhsZRhOmcIaVlMnkKHkOJIvxaqk', appUserID: user.userId });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
